module.exports = __webpack_public_path__ + "img/pIndex-t-slide5.8f12a2a2.jpg";